import React, { useState } from 'react';

const Autocom = () => {
  const suggestions = [
    { label: "Apple", url: "https://example.com/apple" },
    { label: "Banana", url: "https://example.com/banana" },
    { label: "Cherry", url: "https://example.com/cherry" },
    { label: "Date", url: "https://example.com/date" },
    { label: "Fig", url: "https://example.com/fig" },
  ];

  const [inputValue, setInputValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter suggestions based on user input
    const filtered = suggestions.filter(suggestion =>
      suggestion.label.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredSuggestions(filtered);
  };

  const handleSuggestionClick = (suggestion) => {
    // Set the selected suggestion and clear the input
    setSelectedSuggestion(suggestion);
    setInputValue('');
  };

  const handleButtonClick = () => {
    // Handle button click, for example, navigate to the selected URL
    if (selectedSuggestion) {
      window.location.href = selectedSuggestion.url;
    }
  };

  return (
    <div>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Type to search..."
      />

      {filteredSuggestions.length > 0 && (
        <ul>
          {filteredSuggestions.map((suggestion, index) => (
            <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion.label}
            </li>
          ))}
        </ul>
      )}

      {selectedSuggestion && (
        <div>
          {/* <p>Selected: {selectedSuggestion.label}</p> */}
          <button onClick={handleButtonClick}>Go to {selectedSuggestion.label}</button>
        </div>
      )}
    </div>
  );
};

export default Autocom;
